import ScrollReveal from "scrollreveal";

$(function() {
    window.sr = ScrollReveal();

    if ($(window).width() < 768) {
        sr.reveal('.timeline-item-wrap:nth-child(even) .timeline-item', {
            origin: 'left',
            distance: '300px',
            easing: 'ease-in-out',
            duration: 800,
        });
    } else {
        sr.reveal('.timeline-item-wrap:nth-child(even) .timeline-item', {
            origin: 'right',
            distance: '300px',
            easing: 'ease-in-out',
            duration: 800,
        });
    }

    sr.reveal('.timeline-item-wrap:nth-child(odd) .timeline-item', {
        origin: 'left',
        distance: '300px',
        easing: 'ease-in-out',
        duration: 800,
    });

});
